import CampaignV2ListTable from "./campaignV2ListTable.container"

export default CampaignV2ListTable
